import React from 'react';
import { purchaseSteps } from '../data/mock';
import * as Icons from 'lucide-react';
import useScrollAnimation from '../hooks/useScrollAnimation';

const PurchaseProcess = () => {
  const [ref, isVisible] = useScrollAnimation({ threshold: 0.1 });

  const getIcon = (iconName) => {
    const Icon = Icons[iconName];
    return Icon ? <Icon className="w-8 h-8" /> : null;
  };

  return (
    <section ref={ref} className={`py-16 bg-gray-50 fade-in-up ${isVisible ? 'visible' : ''}`}>
      <div className="pp-container">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            فرآیند خرید
          </h2>
          <p className="text-gray-600">مراحل خرید از ما</p>
        </div>

        <div className="relative">
          {/* Connection Line */}
          <div className="hidden md:block absolute top-1/2 right-0 left-0 h-1 bg-gray-200 -translate-y-1/2" style={{ top: '80px' }}></div>
          
          <div className="grid md:grid-cols-4 gap-8 relative">
            {purchaseSteps.map((step, index) => (
              <div key={step.id} className="relative">
                <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-lg transition-all relative z-10">
                  {/* Step Number */}
                  <div className="absolute -top-4 right-6 w-12 h-12 bg-[#005bbb] text-white rounded-full flex items-center justify-center font-bold text-lg shadow-lg">
                    {step.id}
                  </div>
                  
                  {/* Icon */}
                  <div className="flex justify-center mb-4 mt-4">
                    <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center text-[#005bbb]">
                      {getIcon(step.icon)}
                    </div>
                  </div>
                  
                  {/* Content */}
                  <div className="text-center space-y-2">
                    <h3 className="font-bold text-gray-900">{step.title}</h3>
                    <p className="text-sm text-gray-600">{step.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PurchaseProcess;